import axios from "@/api/axiosInstance";

export const exportFileManagerReport = async (): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/admin/reports/file-manager",
    { responseType: "blob" },
  );

  return response.data;
};
